import React from 'react';
// import { Typography } from '@mui/material';
import {
  CakeOutlined,
  IcecreamOutlined,
  AnalyticsOutlined,
  NotificationsActiveOutlined,
} from '@mui/icons-material';
// import ACIcon from './ACIcon';
import { Typography } from '@mui/material';
import { ACIcon } from '@advisorycloud/react-ui-components';

const useStyles = () => ({
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid rgb(230,237,254)',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    position: 'relative',
    width: 225,
    height: 225,
    flexShrink: 0,
  },
  textContainer: {
    position: 'absolute',
    bottom: '9%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: '0.9rem',
    // color: theme.palette.info.dark,
  },
  mainIconContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  planCodeContainer: {
    marginTop: '35px',
    position: 'relative',
  },
  planCodeBackdrop: {
    position: 'absolute',
    width: 33,
    height: 55,
    top: 16,
    right: 12,
    backdropFilter: 'grayscale(60%) opacity(90%)',
  },
  companyCheckoutContainer: {
    marginTop: '47px',
    marginLeft: '-10px',
  },
  companyCheckoutContainerDollar: {
    position: 'absolute',
    width: 'fit-content',
    height: 'fit-content',
    top: 40,
    right: 60,
    fontSize: '2.5rem',
    fontWeight: 100,
    // color: theme.palette.primary.main,
  },
  advisorCheckoutContainer: {
    marginTop: '47px',
    marginLeft: '-10px',
  },
  advisorCheckoutDollar: {
    position: 'absolute',
    width: 'fit-content',
    height: 'fit-content',
    top: 40,
    right: 60,
    fontSize: '2.5rem',
    fontWeight: 100,
    // color: theme.palette.primary.main,
  },
  masterCheckoutContainer: {
    marginTop: '47px',
    marginLeft: '-10px',
    position: 'relative',
  },
  masterCheckoutDollar: {
    position: 'absolute',
    width: 'fit-content',
    height: 'fit-content',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '4.8rem',
    fontWeight: 100,
    // color: theme.palette.primary.main,
  },
  advisorUpdates: {
    marginTop: '50px',
    marginLeft: '-10px',
  },
  advisorUpdatesFile: {
    position: 'absolute',
    width: 'fit-content',
    height: 'fit-content',
    top: 45,
    right: 60,
    fontSize: '2.5rem',
    fontWeight: 100,
    color: 'rgb(15,120,253)',
  },
  manageEmployeesContainer: {
    marginTop: '50px',
    marginLeft: '-10px',
  },
  planMappingContainer: {
    marginTop: '50px',
  },
  buttonStyle: {
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
    outline: 'none',
    border: 'none',
    cursor: 'pointer',
    '&:disabled': {
      cursor: 'default',
    },
  },
});

export default function AdminConsoleTile(props) {
  const { title, type, onClick, disabled } = props;
  const classes = useStyles();

  function iconSelector() {
    if (type === 'plancode') {
      return (
        <div style={classes.planCodeContainer}>
          <div style={classes.planCodeBackdrop} />
          <ACIcon
            iconname="updates-outlined"
            style={{
              fontSize: 85,
              marginLeft: '14px',
              color: 'rgb(15,120,253)',
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          />
        </div>
      );
    }
    if (type === 'companyCheckout') {
      return (
        <div style={classes.companyCheckoutContainer}>
          <div style={classes.companyCheckoutContainerDollar}>{'\uFF04'}</div>
          <ACIcon
            iconname="company-outlined"
            style={{
              fontSize: 70,
              color: '#c4d5ff',
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          />
        </div>
      );
    }
    if (type === 'advisorCheckout') {
      return (
        <div style={classes.advisorCheckoutContainer}>
          <div style={classes.advisorCheckoutDollar}>{'\uFF04'}</div>
          <ACIcon
            iconname="advisor-outlined"
            style={{
              fontSize: 70,
              color: '#c4d5ff',
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          />
        </div>
      );
    }
    if (type === 'masterCheckout') {
      return (
        <div style={classes.masterCheckoutContainer}>
          <div style={classes.masterCheckoutDollar}>{'\uFF04'}</div>
        </div>
      );
    }
    if (type === 'advisoryUpdates') {
      return (
        <div style={classes.advisorUpdates}>
          <div style={classes.advisorUpdatesFile}>
            <ACIcon
              iconname="docs-outlined"
              style={{
                fontSize: 35,
                color: '#c4d5ff',
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                height: 'fit-content',
                width: 'fit-content',
              }}
            />
          </div>
          <ACIcon
            iconname="cloud-logo-outlined"
            style={{
              fontSize: 90,
              color: 'rgb(15,120,253)',
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          />
        </div>
      );
    }
    if (type === 'manageEmployees') {
      return (
        <div style={classes.manageEmployeesContainer}>
          <ACIcon
            iconname="meeting-outlined"
            style={{
              fontSize: 90,
              color: 'rgb(15,120,253)',
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          />
        </div>
      );
    }
    if (type === 'planMapping') {
      return (
        <div style={classes.planMappingContainer}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          >
            <CakeOutlined
              color="primary"
              style={{
                fontSize: 90,
              }}
            />
          </div>
        </div>
      );
    }
    if (type === 'stats') {
      return (
        <div style={classes.planMappingContainer}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          >
            <IcecreamOutlined
              color="primary"
              style={{
                fontSize: 90,
              }}
            />
          </div>
        </div>
      );
    }
    if (type === 'suggestionLogs') {
      return (
        <div style={classes.planMappingContainer}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              height: 'fit-content',
              width: 'fit-content',
            }}
          >
            <AnalyticsOutlined
              color="primary"
              style={{
                fontSize: 90,
              }}
            />
          </div>
        </div>
      );
    }

    if (type === 'pushNotifications') {
      return (
        <div style={classes.planMappingContainer}>
          <NotificationsActiveOutlined
            color="primary"
            style={{
              fontSize: 90,
            }}
          />
        </div>
      );
    }
    if (type === 'pushNotificationLogs') {
      return (
        <div style={classes.planMappingContainer}>
          <AnalyticsOutlined
            color="primary"
            style={{
              fontSize: 90,
            }}
          />
        </div>
      );
    }
  }

  return (
    <button
      style={classes.buttonStyle}
      type="button"
      onClick={() => onClick()}
      disabled={disabled}
    >
      <div style={classes.tileContainer}>
        <div style={classes.mainIconContainer}>{iconSelector()}</div>
        <div style={classes.textContainer}>
          <Typography sx={classes.titleText}>{title}</Typography>
        </div>
      </div>
    </button>
  );
}
